import * as actions from "./AddonActionType"

export const exportParamsRequest = (code: string): actions.ExportParamsRequest => {
  return {
    type: actions.EXPORT_PARAMS_REQUEST,
    payload: { code }
  }
}

export const exportParamsSuccess = (data: any, code: string): actions.ExportParamsSuccess => {
  return {
    type: actions.EXPORT_PARAMS_SUCCESS,
    payload: { data, code }
  }
}

export const exportParamsFailure = (message: string, code: string): actions.ExportParamsFailure => {
  return {
    type: actions.EXPORT_PARAMS_FAILURE,
    payload: { message, code }
  }
}

export const exportParamsReset = (): actions.ExportParamsReset => {
  return {
    type: actions.EXPORT_PARAMS_RESET
  }
}

